/**
 * Logger centralisé — remplace les console.log éparpillés.
 *
 * Phase 8 — Système de notifications centralisé
 *
 * - En production : seuls warn et error sont affichés
 * - En développement : tout est affiché (info, warn, error, debug)
 *
 * Usage :
 *   import logger from '@/utils/logger'
 *   logger.info('message', data)
 *   logger.warn('attention', data)
 *   logger.error('erreur', error)
 *   logger.debug('debug détaillé', obj)
 */

const isDev = process.env.NODE_ENV !== 'production'

const logger = {
  /**
   * Log informatif — masqué en production
   */
  info (msg, ...args) {
    if (isDev) console.log(`[INFO] ${msg}`, ...args)
  },

  /**
   * Avertissement — toujours visible
   */
  warn (msg, ...args) {
    console.warn(`[WARN] ${msg}`, ...args)
  },

  /**
   * Erreur — toujours visible
   */
  error (msg, ...args) {
    console.error(`[ERROR] ${msg}`, ...args)
  },

  /**
   * Debug détaillé — masqué en production
   */
  debug (msg, ...args) {
    if (isDev) console.log(`[DEBUG] ${msg}`, ...args)
  },
}

export default logger
